import React from "react";
import { clients } from "../mockdata";
import { useNavigate } from "react-router-dom";

const Clients = () => {
  const navigate = useNavigate();
  return (
    <section className="relative py-20 px-4 bg-gradient-to-br from-slate-100 via-slate-50 to-white overflow-hidden">
      {/* Faded background image */}
      <img
        src="/images/Picture1.webp"
        alt="Clients background"
        className="absolute inset-0 w-full h-full object-cover opacity-20 blur-sm pointer-events-none select-none z-0"
        aria-hidden="true"
      />
      <div className="max-w-7xl mx-auto relative z-10 px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-2 flex items-center">Our Clients</h2>
            <div className="w-20 h-1 bg-red-600 rounded mb-2"></div>
          </div>
          <button
            className="mt-4 md:mt-0 px-8 py-3 border border-black text-black font-medium hover:bg-black hover:text-white transition rounded text-lg"
            onClick={() => navigate("/clients")}
          >
            Visit All Clients
          </button>
        </div>
        <p className="text-gray-700 text-base md:text-lg mb-12">
          At Milestone Associates, we deeply value the aspirations and visions of our clients. Every project is a distinctive canvas where we apply our innovation. We go beyond being mere consultants; we become your dedicated partners in constructing a future characterized by quality, dependability, and excellence. Join us on this journey as we push the boundaries of what is achievable in the MEP sector, crafting spaces that epitomize innovation and technical mastery.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8 justify-items-center">
          {clients.slice(0, 6).map((client, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-lg w-full sm:w-44 p-3 overflow-hidden flex items-center justify-center">
              <img
                src={client.logo}
                alt={client.name}
                className="h-full w-full object-contain"
                title={client.name}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;